export default __webpack_public_path__ + "1d2fbc91f900cedca5fe57f33833a396.png";